import { render, staticRenderFns } from "./TableContacts.vue?vue&type=template&id=56ede8ba&"
import script from "./TableContacts.vue?vue&type=script&lang=js&"
export * from "./TableContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports